/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';

function MVPDMetadataItemEditViewController(this: JS5Object, _: JS5Object, $location: JS5Object, $route: JS5Object, $routeParams: JS5Object,
											uiGridConstants: JS5Object, NetworkViewService: JS5Object, $timeout: JS5Function,
											BreadcrumbService: JS5Object, MVPDViewService: JS5Object, PermissionsService:JS5Object,
											ContentResourceFactory: JS5Object, NavbarUtilService: JS5Object,
											NotificationService: JS5Object, MetadataService: JS5Object,
                                            SidebarService: JS5Object) {
	let initializeBreadcrumbs = () => {
		BreadcrumbService.clearBreadcrumbs();
		BreadcrumbService.addBreadcrumb({
			name: 'MVPD Partners',
			location: $route.current.rootRoute
		});

		BreadcrumbService.addBreadcrumb({
			name: this.mvpdConfig.partnerName,
			location: this.mvpdConfig.parentLocation
		});
	};

	let getPromiseKey = (method: string, criteria: JS5Object): string => {
		if ($routeParams.view === 'properties' || $routeParams.subView === 'properties') {
			criteria.id = $routeParams.groupId;
			if ($routeParams.view === 'seasons' || $routeParams.view === 'volumes') {
				criteria.id = $routeParams.seasonVolumeId;
				return `${method}${_.upperFirst($routeParams.view.substring(0, $routeParams.view.length - 1))}`;
			} else {
				if ($routeParams.groupName === 'networks') {
					return `${method}Network`;
				}
				return `${method}Content`;
			}
		} else {
			criteria.contentId = $routeParams.groupId;
			if ($routeParams.view === 'seasons' || $routeParams.view === 'volumes') {
				return `${method}${_.upperFirst($routeParams.view)}`;
			}
			return `${method}Content`;
		}
	};

	let getGroupName = (): string => {
		if ($routeParams.groupName === 'networks') {
			return 'Network';
		} else if ($routeParams.groupName === 'movies') {
			return 'Movie/Special';
		} else {
			if ($routeParams.seasonVolumeId) {
				return _.upperFirst($routeParams.view.substring(0, $routeParams.view.length - 1));
			}
			return 'Series'
		}
	};

	let getData = () => {
		this.loadingIndicator.show = true;

		this.isSeries = $routeParams.groupName === 'series';

		let criteria: any = {
			mvpdPartnerId: $routeParams.id
		};

		let groupSearchDataPromises: JS5Object = {
			getNetwork: (): void => NetworkViewService.getEditViewData(criteria),
			getContent: (): void => ContentResourceFactory.getMVPDContent(criteria).$promise,
			getSeason: (): void => ContentResourceFactory.getSeason(criteria).$promise,
			getVolume: (): void => ContentResourceFactory.getVolume(criteria).$promise,
			getSeasons: (): void => ContentResourceFactory.getSeasons(criteria).$promise,
			getVolumes: (): void => ContentResourceFactory.getVolumes(criteria).$promise
		};

		let setEditData = (editData: JS5Object) => {
            MVPDViewService.originalEditData = _.cloneDeep(editData);
            this.editData = editData;
            this.loadingIndicator.show = false;
        };

		groupSearchDataPromises[getPromiseKey('get', criteria)]().then((groupData: JS5Object): void => {
			if (this.activeTabs.properties) {
				MVPDViewService.getMetadataByGroup(getGroupName(), groupData).then((groupData: JS5Object) => {
                    let seasonVolume = $routeParams.view === 'seasons' || $routeParams.view === 'volumes';
                    if (seasonVolume) {
                        criteria.id = $routeParams.groupId;
                        groupSearchDataPromises['getContent']().then((contentData: JS5Object): void => {
                            BreadcrumbService.addBreadcrumb({
                                name: contentData.name,
                                location: this.mvpdConfig.parentLocation
                            });
                            setEditData(groupData);
                        });
                    } else {
                        setEditData(groupData);
                    }
				});
			} else {
			    delete criteria.contentId;
			    criteria.id = $routeParams.groupId;
                groupSearchDataPromises['getContent']().then((contentData: JS5Object): void => {
                    this.gridOptions.data = groupData;
                    this.editData = contentData;
                    this.loadingIndicator.show = false;
                });
			}
		});
	};

	let navigateToSeasonVolumeMetadataEditView = (seasonVolumeId: JS5Object): void => {
		$location.url(`/meta/mvpd/edit/partner/${$routeParams.id}/${$routeParams.groupName}/${$routeParams.groupId}/metadata/${$routeParams.view}/${seasonVolumeId}/edit/properties`);
	};

	let saveEditData = () => {
		this.loadingIndicator.show = true;

		// **************************************************************** //
        // **************************************************************** //
		// **** Seriously! Always perform this action before you save  **** //
		// **** metadata items to ensure the correct data is persisted **** //
        // **************************************************************** //
        // **************************************************************** //
		let cleanData = MetadataService.cleanData(this.editData, MVPDViewService.getComponentsMap(undefined));

		let groupPromises: JS5Object = {
			saveNetwork: (): void => NetworkViewService.saveNetwork(cleanData),
			saveContent: (): void => ContentResourceFactory.update(cleanData).$promise,
			saveSeason: (): void => ContentResourceFactory.updateSeason({seasonId: $routeParams.seasonVolumeId}, cleanData).$promise,
			saveVolume: (): void => ContentResourceFactory.updateVolume({volumeId: $routeParams.seasonVolumeId}, cleanData).$promise
		};

		groupPromises[getPromiseKey('save', {})]().then((editData: JS5Object): void => {
			MVPDViewService.getMetadataByGroup(getGroupName(), editData).then((editData: JS5Object) => {
				MVPDViewService.originalEditData = _.cloneDeep(editData);
				this.editData = editData;
				this.loadingIndicator.show = false;
				this.editorForm.$pristine = true;
				this.editorForm.$setPristine();
			});
		});
	};

    // **************************************************************** //
    // **************************************************************** //
    // **** Seriously! Always perform this action before you save  **** //
    // **** metadata items to ensure the correct data is persisted **** //
    // **************************************************************** //
    // **************************************************************** //
	this.onUpdate = (event: any) => {
		this.validationErrors = event.errors;
		if (!this.validationErrors) {
			MVPDViewService.getComponentsMap(undefined)[event.name].instanceData.value = event.items;
		}
	};

	this.getComponentsMap = () => {
		return MVPDViewService.getComponentsMap();
	};

	this.hasMetadataProperties = (entity: JS5Object) => {
		return !_.isEmpty(entity.metadata.properties);
	};

	this.onRowDblClick = (row: JS5Object) => {
		if (this.hasMetadataProperties(row.entity)) {
			navigateToSeasonVolumeMetadataEditView(row.entity.id);
		}
	};

	this.onTabSelect = (tab: string): void => {
		let param = (this.seasonVolumeId) ? {subView: tab} : {view: tab};
		$route.updateParams(param);
	};

	let showUnsavedChangesWarning = (): void => {
		var message = 'You have unsaved changes.  Please save or revert.';
		NotificationService.createWarningNotification(message, '');
	};

	this.onTabDeselect = (tab: string, event: any): void => {
		if (this.editorForm && this.editorForm.$dirty) {
			event.preventDefault();
			showUnsavedChangesWarning();
		}
	};

	this.getFieldErrorsTooltip = (missingMVPDFields: JS5Object[]): string => {
		return MVPDViewService.getFieldErrorsTooltip(missingMVPDFields);
	};

	this.columnDefinitions = [
		{
			field: 'name',
			displayName: 'Name',
			sort: {
				direction: 'asc',
			},
			cellTemplate: 'components/visual/grid/mvpd-required-error-template.html'
		}
	];

	this.gridOptions = {
		rowSelection: true,
		enableRowHeaderSelection: false,
		enableSelectAll: false,
		enableColumnResizing: true,
		enablePaginationControls: false,
		enableSorting: true,
		enableColumnMenus: false,
		enableFullRowSelection: true,
		enableHorizontalScrollbar: uiGridConstants.ALWAYS,
		enableVerticalScrollbar: uiGridConstants.ALWAYS,
		rowHeight: 26,
		multiSelect: false,
		columnDefs: this.columnDefinitions,
		onRegisterApi: (gridApi: JS5Object): void => {
			this.gridApi = gridApi;
		},
		rowTemplate: `<div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid"
						   ng-class="{ 'ui-grid-cell-hidden' : row.entity.hidden || (row.entity.mvpdPartnerId && !grid.appScope.$ctrl.hasMetadataProperties(row.entity))}"
						   class="ui-grid-cell ng-scope ng-binding"
						   ui-grid-cell
						   ng-dblclick="grid.appScope.$ctrl.onRowDblClick(row)">
					 </div>`,
		data: []
	};

	this.toolbarButtonDefs = [
		{
			label: 'Edit',
			enabled: (): boolean => {
				return this.gridApi && this.gridApi.selection.getSelectedCount() === 1 && this.hasMetadataProperties(this.gridApi.selection.getSelectedRows()[0]);
			},
			onClick: (): void => {
				navigateToSeasonVolumeMetadataEditView(this.gridApi.selection.getSelectedRows()[0].id);
			}
		},
		{
			label: 'Save',
			enabled: () => this.editorForm && !this.editorForm.$pristine && !this.validationErrors,
			onClick: saveEditData
		},
		{
			label: 'Revert',
			enabled: () => this.editorForm && !this.editorForm.$pristine,
			onClick: () => {
				MVPDViewService.revertMVPDEditData();
				this.editorForm.$pristine = true;
				this.editorForm.$setPristine();
			}
		},
		{
			label: 'Close',
			enabled: () => {
				return (this.editorForm && !this.editorForm.$dirty) || this.currentTab !== 'properties';
			},
			onClick: () => $location.url(this.mvpdConfig.parentLocation)
		}
	];

	this.$onInit = () => {
        SidebarService.editService = MVPDViewService;
		initializeBreadcrumbs();
		this.loadingIndicator = {
			backdrop: true,
			show: false,
			title: 'Working',
			message: 'Please wait...'
		};

		this.activeTabs = {
			properties: false,
			seasons: false,
			volumes: false
		};

		this.seasonVolumeId = $routeParams.seasonVolumeId;

		if (this.seasonVolumeId) {
			this.currentTab = 'properties';
			this.activeTabs.properties = true;
		} else {
			this.currentTab = $routeParams.view;
			this.activeTabs[$routeParams.view] = true;
			NavbarUtilService.viewSearchFunction = getData;
		}

        PermissionsService.getReadWritePermissions(MVPDViewService.permissionViewState).then((permissions:JS5Object) => {
            this.permissions = permissions;
            getData();
        });
	};

	this.$postLink = () => {
		$timeout(() => {
			MVPDViewService.editorForm = this.editorForm;
			BreadcrumbService.editService = MVPDViewService;
		});
	};

	this.$onDestroy = () => {
		BreadcrumbService.clearBreadcrumbs();
		this.editData = null;
        MVPDViewService.getComponentsMap({});
	};
}

angular.module('prism-ui.mvpd').component('mvpdMetadataItemEditView', {
	templateUrl: 'meta/mvpd/metadataEditView/mvpd-metadata-item-edit-view-template.html',
	controller: MVPDMetadataItemEditViewController,
	bindings: {
		mvpdConfig: "<"
	}
});
